export function handleLogout(callback) {
  localStorage.removeItem('token');
  localStorage.removeItem('properties');
  if (callback) callback();
}

export function responseToJson(response) {
  return response.json();
}

export function storeToken(response) {
  const token = response.headers.get('authorization');
  localStorage.setItem("token", token);

  return response;
}

export function handleResponse(response) {
  if (!response.ok) {
    // auto logout if 401 response returned from api
    if (response.status == 401) handleLogout();
    return responseToJson(response).then(json => Promise.reject(json));
  }

  return response;
}
